(function() {
  if (window.SWHProductDetail) return;

  function initBackButton(root, options) {
    if (!root) return function() {};

    var opts = options || {};
    var selector = opts.selector || '[data-swh-back]';
    var fallbackAttr = opts.fallbackAttr || 'href';
    var button = root.querySelector(selector);
    if (!button || button.dataset.swhBackInit === 'true') return function() {};

    var onClick = function(event) {
      event.preventDefault();
      var fallbackHref = button.getAttribute(fallbackAttr) || '/';
      var referrer = document.referrer || '';
      var sameOriginReferrer = false;

      try {
        sameOriginReferrer = !!referrer && new URL(referrer, window.location.origin).origin === window.location.origin;
      } catch (err) {
        sameOriginReferrer = false;
      }

      if (sameOriginReferrer && referrer !== window.location.href) {
        window.location.href = referrer;
        return;
      }

      if (window.history.length > 1) {
        window.history.back();
        return;
      }

      window.location.href = fallbackHref;
    };

    button.dataset.swhBackInit = 'true';
    button.addEventListener('click', onClick);

    return function destroyBackButton() {
      button.removeEventListener('click', onClick);
      delete button.dataset.swhBackInit;
    };
  }

  function initGallery(root, options) {
    if (!root) return null;

    var opts = options || {};
    var bodyClass = opts.bodyClass || 'swh-product-gallery-open';
    var stageButton = root.querySelector(opts.stageSelector || '[data-gallery-open]');
    var mainImage = root.querySelector(opts.mainImageSelector || '[data-gallery-main-image]');
    if (!stageButton || !mainImage) return null;

    var thumbButtons = Array.prototype.slice.call(root.querySelectorAll(opts.thumbSelector || '[data-gallery-thumb]'));
    var lightbox = root.querySelector(opts.lightboxSelector || '[data-gallery-lightbox]');
    var lightboxStage = root.querySelector(opts.lightboxStageSelector || '[data-gallery-lightbox-stage]');
    var lightboxImage = root.querySelector(opts.lightboxImageSelector || '[data-gallery-lightbox-image]');
    var lightboxThumbButtons = Array.prototype.slice.call(root.querySelectorAll(opts.lightboxThumbSelector || '[data-gallery-lightbox-thumb]'));
    var mainCounter = root.querySelector(opts.mainCounterSelector || '[data-gallery-counter]');
    var lightboxCounter = root.querySelector(opts.lightboxCounterSelector || '[data-gallery-lightbox-counter]');
    var prevButtons = Array.prototype.slice.call(root.querySelectorAll(opts.prevSelector || '[data-gallery-prev], [data-gallery-lightbox-prev]'));
    var nextButtons = Array.prototype.slice.call(root.querySelectorAll(opts.nextSelector || '[data-gallery-next], [data-gallery-lightbox-next]'));
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll(opts.closeSelector || '[data-gallery-close]'));
    var listeners = [];

    function listen(target, eventName, handler, eventOptions) {
      if (!target) return;
      target.addEventListener(eventName, handler, eventOptions);
      listeners.push(function() {
        target.removeEventListener(eventName, handler, eventOptions);
      });
    }

    var fallbackItem = {
      index: 0,
      mediaId: String(mainImage.getAttribute('data-media-id') || ''),
      mainSrc: String(mainImage.getAttribute('data-main-src') || mainImage.getAttribute('src') || ''),
      mainSrcset: String(mainImage.getAttribute('data-main-srcset') || mainImage.getAttribute('srcset') || ''),
      lightboxSrc: String(mainImage.getAttribute('data-lightbox-src') || mainImage.getAttribute('src') || ''),
      lightboxSrcset: String(mainImage.getAttribute('data-lightbox-srcset') || mainImage.getAttribute('srcset') || ''),
      alt: String(mainImage.getAttribute('alt') || ''),
      width: Number(mainImage.getAttribute('width') || 0),
      height: Number(mainImage.getAttribute('height') || 0)
    };

    var items = thumbButtons.length
      ? thumbButtons
          .map(function(button) {
            return {
              index: Number(button.getAttribute('data-index') || 0),
              mediaId: String(button.getAttribute('data-media-id') || ''),
              mainSrc: String(button.getAttribute('data-main-src') || ''),
              mainSrcset: String(button.getAttribute('data-main-srcset') || ''),
              lightboxSrc: String(button.getAttribute('data-lightbox-src') || ''),
              lightboxSrcset: String(button.getAttribute('data-lightbox-srcset') || ''),
              alt: String(button.getAttribute('data-alt') || ''),
              width: Number(button.getAttribute('data-width') || 0),
              height: Number(button.getAttribute('data-height') || 0)
            };
          })
          .sort(function(a, b) {
            return a.index - b.index;
          })
      : [fallbackItem];

    if (!items.length) return null;

    var state = {
      index: 0,
      lightboxOpen: false,
      suppressStageClick: false
    };

    function clampIndex(value) {
      var max = items.length;
      if (!max) return 0;
      return ((value % max) + max) % max;
    }

    function updateImageElement(img, item, mode) {
      if (!img || !item) return;
      var src = mode === 'lightbox' ? item.lightboxSrc : item.mainSrc;
      var srcset = mode === 'lightbox' ? item.lightboxSrcset : item.mainSrcset;
      if (src) img.src = src;
      if (srcset) img.srcset = srcset;
      img.alt = item.alt || '';
      if (item.width) img.width = item.width;
      if (item.height) img.height = item.height;
    }

    function syncThumbState(buttons, activeIndex) {
      buttons.forEach(function(button) {
        var idx = Number(button.getAttribute('data-index') || -1);
        var isActive = idx === activeIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive) {
          button.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      });
    }

    function updateCounters() {
      var text = state.index + 1 + ' / ' + items.length;
      if (mainCounter) mainCounter.textContent = text;
      if (lightboxCounter) lightboxCounter.textContent = text;
    }

    function setIndex(nextIndex, setIndexOptions) {
      var localOptions = setIndexOptions || {};
      state.index = clampIndex(nextIndex);
      var item = items[state.index];
      updateImageElement(mainImage, item, 'main');
      if (lightboxImage && state.lightboxOpen) updateImageElement(lightboxImage, item, 'lightbox');
      syncThumbState(thumbButtons, state.index);
      syncThumbState(lightboxThumbButtons, state.index);
      updateCounters();
      if (localOptions.syncStageDataset !== false && stageButton && item.mediaId) {
        stageButton.setAttribute('data-active-media-id', item.mediaId);
      }
    }

    function go(delta) {
      if (items.length < 2) return;
      setIndex(state.index + delta);
    }

    function openLightbox() {
      if (!lightbox || state.lightboxOpen) return;
      state.lightboxOpen = true;
      if (lightboxImage) updateImageElement(lightboxImage, items[state.index], 'lightbox');
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add(bodyClass);
      updateCounters();
    }

    function closeLightbox() {
      if (!lightbox || !state.lightboxOpen) return;
      state.lightboxOpen = false;
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(bodyClass);
    }

    function bindSwipe(interactiveElement, onSwipe) {
      if (!interactiveElement || items.length < 2) return;

      var pointerId = null;
      var startX = 0;
      var startY = 0;
      var dx = 0;
      var dy = 0;
      var dragging = false;
      var moved = false;

      function reset() {
        pointerId = null;
        dx = 0;
        dy = 0;
        dragging = false;
        moved = false;
        interactiveElement.classList.remove('is-dragging');
        interactiveElement.style.setProperty('--swh-gallery-drag-x', '0px');
      }

      function onPointerDown(event) {
        if (event.button !== undefined && event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        dx = 0;
        dy = 0;
        dragging = false;
        moved = false;
        if (interactiveElement.setPointerCapture) {
          try {
            interactiveElement.setPointerCapture(pointerId);
          } catch (err) {
            /* ignore */
          }
        }
      }

      function onPointerMove(event) {
        if (pointerId === null || event.pointerId !== pointerId) return;
        dx = event.clientX - startX;
        dy = event.clientY - startY;

        if (!dragging) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dx) <= Math.abs(dy)) return;
          dragging = true;
          interactiveElement.classList.add('is-dragging');
        }

        moved = Math.abs(dx) > 8;
        interactiveElement.style.setProperty('--swh-gallery-drag-x', dx + 'px');
        if (event.cancelable) event.preventDefault();
      }

      function onPointerEnd(event) {
        if (pointerId === null || event.pointerId !== pointerId) return;
        var finalDx = dx;
        var finalDy = dy;
        var didDrag = dragging || moved;
        reset();

        if (didDrag && Math.abs(finalDx) > 52 && Math.abs(finalDx) > Math.abs(finalDy)) {
          onSwipe(finalDx < 0 ? 1 : -1);
        }

        if (interactiveElement === stageButton && didDrag) {
          state.suppressStageClick = true;
          window.setTimeout(function() {
            state.suppressStageClick = false;
          }, 0);
        }
      }

      function onPointerLeave(event) {
        if (!dragging) return;
        onPointerEnd(event);
      }

      listen(interactiveElement, 'pointerdown', onPointerDown);
      listen(interactiveElement, 'pointermove', onPointerMove);
      listen(interactiveElement, 'pointerup', onPointerEnd);
      listen(interactiveElement, 'pointercancel', onPointerEnd);
      listen(interactiveElement, 'pointerleave', onPointerLeave);
    }

    thumbButtons.forEach(function(button) {
      listen(button, 'click', function() {
        setIndex(Number(button.getAttribute('data-index') || 0));
      });
    });

    lightboxThumbButtons.forEach(function(button) {
      listen(button, 'click', function() {
        setIndex(Number(button.getAttribute('data-index') || 0));
      });
    });

    prevButtons.forEach(function(button) {
      listen(button, 'click', function() {
        go(-1);
      });
    });

    nextButtons.forEach(function(button) {
      listen(button, 'click', function() {
        go(1);
      });
    });

    if (stageButton) {
      listen(stageButton, 'click', function(event) {
        if (state.suppressStageClick) {
          event.preventDefault();
          return;
        }
        openLightbox();
      });
    }

    closeButtons.forEach(function(button) {
      listen(button, 'click', function(event) {
        event.preventDefault();
        closeLightbox();
      });
    });

    function onKeyDown(event) {
      if (!state.lightboxOpen) return;
      if (event.key === 'Escape') {
        closeLightbox();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(-1);
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(1);
      }
    }

    listen(document, 'keydown', onKeyDown);
    bindSwipe(stageButton, function(delta) {
      go(delta);
    });
    bindSwipe(lightboxStage, function(delta) {
      go(delta);
    });

    var initialMediaId = String(mainImage.getAttribute('data-media-id') || '');
    var initialIndex = items.findIndex(function(item) {
      return String(item.mediaId) === initialMediaId;
    });
    setIndex(initialIndex >= 0 ? initialIndex : 0, { syncStageDataset: false });

    return {
      close: closeLightbox,
      destroy: function() {
        closeLightbox();
        listeners.splice(0).forEach(function(removeListener) {
          removeListener();
        });
      },
      selectByMediaId: function(mediaId) {
        if (!mediaId) return;
        var idx = items.findIndex(function(item) {
          return String(item.mediaId) === String(mediaId);
        });
        if (idx >= 0) setIndex(idx);
      },
      setIndex: setIndex
    };
  }

  window.SWHProductDetail = {
    initBackButton: initBackButton,
    initGallery: initGallery
  };
  window.dispatchEvent(new Event('swh:product-detail:ready'));
})();
